module.exports = "/virtual-football-league/img/video/result-logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/result-logo.png
// module id = 2246
// module chunks = 4